import React from 'react';
import { connect } from 'react-redux';

import PageHeader from '../../modules/PageHeader';
import PageMeta from '../../modules/PageMeta';
import SidebarColumn from '../../modules/SidebarColumn';
import PageSidebar from '../../modules/PageSidebar';
import ContentColumn from '../../modules/ContentColumn';
import PageSection from '../../modules/PageSection';
import Page from '../../pages/Page';
import MyDataForm from '../../forms/MyData';

import * as removalActions from '../../../actions/removal';

class MyData extends React.Component {

    _sendDataEnquiry(values) {
        return this.props.sendDataEnquiry(values);
    }

    render() {
        return (
            <Page>
                <PageMeta title="My Data" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>
                    <PageHeader>
                        <h1>My Data</h1>

                        <span>Enquire about the data which RHE Global services hold about you.</span>
                    </PageHeader>

                    <PageSection>
                        <MyDataForm onSubmit={this._sendDataEnquiry.bind(this)} />
                    </PageSection>
                </ContentColumn>
            </Page>
        )
    }
}

function mapStateToProps() {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        sendDataEnquiry(values) {
            return dispatch(removalActions.sendDataEnquiry(values));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyData);